export default () => ({
  uploadTestResultImageData: undefined,
  currentChannel: {},
  controlChannel: {},
  mergeChannel: {},
  healthTags: [],
  channelListener: null
})
